module.exports = __webpack_public_path__ + "static/img/contact_title3.1b6f453.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/contact_title3.png
// module id = 62FU
// module chunks = 4